import { AdminClientReportsTable } from './AdminClientReportsTable';

export default AdminClientReportsTable;
